/**
 * Firestore helper utilities
 */

/**
 * Removes undefined values from an object before saving to Firestore.
 * Firestore does not accept undefined values - use null to clear a field.
 * @param {Object} obj - The object to sanitize
 * @returns {Object} A new object with undefined values removed
 */
export function sanitizeForFirestore(obj) {
  if (!obj || typeof obj !== "object") {
    return obj;
  }

  return Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v !== undefined)
  );
}
